import aboutImage03 from '@/assets/images/about/about_03.png'
import aboutImage04 from '@/assets/images/about/about_04.png'
import aboutImage05 from '@/assets/images/about/about_05.png'
import { SEO } from '@/components/seo/seo'
import MenuInfo from '../menu/menuInfo'
import { MenuHeader } from '../menu/menuHeader'
import { useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './aboutUs.css'
import { useResponsive } from '@/hooks/useResponsive'

// 메뉴별 경로 매핑
const menuLinks: Record<string, string> = {
  골프장검색: '/golf/detailSearch',
  골플루언서: '/youtube',
  목소리: '/feedback',
  투표: '/survey',
  소통: '/blog',
  문의: '/inquiry',
  정보: '/promotion',
  공지사항: '/notice',
}

const BottomInfo = () => {
  const navigate = useNavigate()

  const menuItems = [
    {
      title: '골프장검색',
      desc: '전국 골프장의 위치, 가격, 예약 정보를 쉽고 빠르게 검색할 수 있습니다.',
    },
    {
      title: '골플루언서',
      desc: '골프 레슨, 필드 영상, 다양한 정보 등 대한민국 골프 유튜브 채널을 소개합니다.',
    },
    {
      title: '목소리',
      desc: '골퍼가 다녀온 골프장의 칭찬, 반성 후기를 통해 더 나은 골프문화를 공유하기 위한 공간입니다.',
    },
    {
      title: '투표',
      desc: '다양한 주제의 설문 및 투표에 참여하여 골프 트렌드를 만들어갑니다.',
    },
    {
      title: '소통',
      desc: '유저들끼리 자유롭게 정보를 공유하고 질문할 수 있는 커뮤니티 공간입니다.',
    },
    {
      title: '문의',
      desc: '서비스 이용 중 불편하거나 궁금한 점이 있다면 언제든지 문의해 주세요. 신속하게 도와드리겠습니다.',
    },
    {
      title: '정보',
      desc: '골프 관련 이벤트 등 다양한 정보를 한눈에 확인할 수 있습니다.',
    },
    {
      title: '공지사항',
      desc: '사이트 이용과 관련된 중요한 소식과 공지를 확인하세요.',
    },
  ]

  return (
    <div className="bottom-info-container">
      <div className="bottom-info">
        <h4 className="menu-title">Site Menu Guide</h4>
        <div className="menu-list">
          {menuItems.map((item, idx) => (
            <div key={idx} className="menu-item">
              <button
                type="button"
                className="shortcut-button"
                onClick={() => {
                  const url = menuLinks[item.title]
                  if (url) {
                    navigate(url)
                    window.scrollTo(0, 0)
                  }
                }}
                aria-label={`${item.title} 바로가기`}
              >
                바로가기
              </button>
              <h5 className="menu-item-title">{item.title}</h5>
              <p className="menu-item-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const AboutUs = () => {
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const { isMobile, isTablet, isDesktop } = useResponsive()

  const sections = [
    {
      title: '골프 정보의 모든 것, 한곳에',
      text: '국내 주요 골프장 정보와 실시간 그린피 시세를 제공하며, 골프를 사랑하는 유저들이 소통할 수 있는 커뮤니케이션 서비스를 통해 골프 문화를 선도합니다.',
      imgSrc: aboutImage04,
    },
    {
      title: '신뢰할 수 있는 골프 시세 정보',
      text: '투명하고 정확한 데이터를 기반으로 그린피 시세를 실시간으로 제공합니다. 골프 관련 중요한 결정을 내리는 데 필요한 모든 정보를 제공합니다.',
      imgSrc: aboutImage05,
    },
    {
      title: '골퍼들을 위한 커뮤니티',
      text: '골프를 사랑하는 유저들이 모여 정보를 나누고 소통할 수 있는 공간을 제공합니다. 경험과 노하우를 공유하며 더 나은 골프 라이프를 만들어갑니다.',
      imgSrc: aboutImage03,
    },
  ]

  return (
    <>
      <SEO
        title="꿀프소개"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/about"
      />
      <div style={{ padding: isMobile ? '0 16px' : '0' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={false}
          menuInfoRef={menuInfoRef}
          loginRequired={false}
          iconActive={hasMenuInfo}
        />
      </div>
      <div className="about-us-container">
        {sections.map((section, index) => (
          <div key={index} className="section">
            <div className="about-image-container">
              <img src={section.imgSrc} alt={section.title} />
            </div>
            <div className="text-container">
              <h3>{section.title}</h3>
              <p>{section.text}</p>
            </div>
          </div>
        ))}
      </div>
      <div ref={menuInfoRef}>
        <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
      </div>
      <BottomInfo />
    </>
  )
}

export default AboutUs
